export type TimeRangePreset = 'all' | 'today' | '7d' | '30d' | '90d' | 'year';

export const TIME_RANGE_LABELS: Record<TimeRangePreset, string> = {
  all: 'All time',
  today: 'Today',
  '7d': 'Last 7 days',
  '30d': 'Last 30 days',
  '90d': 'Last 90 days',
  year: 'This year',
};

/** Short labels for compact chip UIs (e.g. sidebar) */
export const TIME_RANGE_SHORT_LABELS: Record<TimeRangePreset, string> = {
  all: 'Any time',
  today: 'Today',
  '7d': '7 days',
  '30d': '30 days',
  '90d': '90 days',
  year: 'This year',
};

/** Preset order for filter chips */
export const TIME_RANGE_PRESET_ORDER: TimeRangePreset[] = [
  'all',
  'today',
  '7d',
  '30d',
  '90d',
  'year',
];

/** Minimum `addedOn` (ms) inclusive; `null` means no time filter. */
export function getTimeRangeStartMs(preset: TimeRangePreset): number | null {
  if (preset === 'all') return null;
  const now = Date.now();
  if (preset === 'today') {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d.getTime();
  }
  if (preset === '7d') return now - 7 * 24 * 60 * 60 * 1000;
  if (preset === '30d') return now - 30 * 24 * 60 * 60 * 1000;
  if (preset === '90d') return now - 90 * 24 * 60 * 60 * 1000;
  if (preset === 'year') {
    const d = new Date();
    d.setMonth(0, 1);
    d.setHours(0, 0, 0, 0);
    return d.getTime();
  }
  return null;
}
